<template>
  <v-row>
    <v-col lg="10" offset-lg="1" class="mt-2" cols="12">
      <v-breadcrumbs :items="items" divider=">" class="pl-1 pb-3" />

      <v-card>
        <v-card-title class="theme white--text">
          <v-icon class="white--text mr-2">account_box</v-icon>
          Employee profile
          <v-spacer />
          <v-btn
              class="rounded-sm action white--text"
              v-if="isHROrEmployeeManager"
              @click="edit"
          >Edit
          </v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-row class="py-4">
            <v-col cols="12" lg="3" class="hidden-md-and-down">
              <v-avatar
                  class="ma-3"
                  size="220"
                  v-if="profile_image_url"
                  rounded
                  style="border: 8px solid #f8f6f4; background-color: #f8f6f4"
              >
                <v-img :src="profile_image_url" :alt="name" style="border-radius: 7%"/>
              </v-avatar>
              <v-avatar size="200" class="grey lighten-2 my-1 display-2" :style="{color:getColorFromName(`${id}`)}" v-else>
                {{ name ? getNameInitials(name) : '' }}
              </v-avatar>
            </v-col>
            <v-col cols="12" lg="9">
              <div class="text-left pt-2 ml-5 darkertext">
                <div
                  class="headline text-capitalize"
                  v-if="name"
                  v-text="name"
                />
                <div class="mb-8 subtitle-1" style="margin-top: -0.3rem">
                  {{ jobTitle }}
                </div>

                <div class="row body-2">
                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Work email
                  </div>
                  <div class="col-xs-12 col-sm-10 py-0">{{ email }}</div>

                  <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                    Phone
                  </div>
                  <div class="col-xs-12 col-sm-10 py-0 mb-5">
                    {{ phone_num }}
                  </div>
                </div>

                <div class="text-left pt-2 mt-4">
                  <div class="row body-2">
                    <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                      Department
                    </div>
                    <div class="col-xs-12 col-sm-10 py-0">{{ department }}</div>
                    <div class="col-xs-12 col-sm-2 py-0 font-weight-bold">
                      Job location
                    </div>
                    <div class="col-xs-12 col-sm-10 py-0">
                      {{ location }}
                    </div>
                    <div
                      class="col-xs-12 col-sm-2 py-0 font-weight-bold"
                      v-if="manager"
                    >
                      Manager
                    </div>
                    <router-link
                      :to="{
                        name: manager_profile,
                        params: { id: manager_id },
                      }"
                      tag="a"
                      v-if="manager_id"
                    >
                      <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 py-0 mb-5"
                      >
                        <a class="text-capitalize">{{ manager }}</a>
                      </div>
                    </router-link>
                    <div
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 py-0 font-weight-bold"
                      v-if="direct_reports"
                    >
                      Direct reports
                    </div>
                    <div
                      class="col-xs-12 col-sm-12 col-lg-12 py-0 mb-5"
                      v-if="direct_reports"
                    >
                      <ul id="example-1">
                        <li v-for="item in direct_reports" :key="item.id">
                          <span class="text-capitalize">{{ item.name }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapGetters} from 'vuex';

import {Actions} from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component} from '@/views/component';
import {Constants} from "@/views/constants";

export default {
  name: Component.Protected.Employee.Profile,
  computed: {
    ...mapGetters(['userInfo']),
    isHROrEmployeeManager() {
      if (this.userInfo.role === Constants.Roles.HR) {
        return true
      }
      return this.userInfo.role === Constants.Roles.Manager
          && parseInt(this.manager_id) === parseInt(this.userInfo.userID);
    },
  },
  data: () => ({
    items: Breadcrumbs.Employee.Profile,
    jobTitle: null,
    location: null,
    department: null,
    manager: null,
    name: null,
    phone_num: null,
    email: null,
    direct_reports: null,
    profile_image_url: null,
    manager_profile: Component.Protected.Employee.Profile,
    manager_id: null,
  }),
  watch: {
    $route(to, from) {
      this.getprofile();
    },
  },
  methods: {
    edit() {
      this.$router.push({
        name: Component.Protected.Employee.Edit,
        params: {id: this.$route.params.id},
      });
    },

    setup() {
      if (!this.$route.params.id) {
        this.$router.go(-1);
        return false;
      }
      this.id = `${this.$route.params.id}`;
      this.getprofile();
    },
    getprofile() {
      this.$store
        .dispatch(Actions.Employee.Profile, this.$route.params.id)
        .then((r) => {
          if (r.status === 200 && r.data) {
            this.jobTitle = r.data.user_info.job_title;
            this.location = r.data.user_info.job_location;
            this.department = r.data.user_info.department;
            this.manager = r.data.user_info.manager;
            this.name = r.data.user_info.name;
            this.phone_num = r.data.user_info.phone_number;
            this.email = r.data.user_info.email;
            this.direct_reports = r.data.reports;
            this.profile_image_url = r.data.user_info.profile_image_url;
            this.manager_id = r.data.user_info.manager_id;
          }
        })
        .catch((err) => console.error(err));
    },
  },
  created() {
    if (this.userInfo) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
